import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ETagPropertyDataType } from 'app/shared/enums';
import { ISelectedTag } from '../interfaces/tag-type';
import { ITranslate } from 'app/shared/constants';

@Component({
  selector: 'tag-value-model',
  templateUrl: './tag-value-dialog-model.component.html',
  styleUrls: ['./tag-value-dialog-model.component.scss'],
})

export class TagValueComponent implements OnInit {
  dynamicForm: FormGroup;
  submitted: boolean = false;
  allUsedItems: ISelectedTag[] = [];
  dataTypes = ETagPropertyDataType;
  trans: ITranslate = { text: '' }; // for translation

  constructor(private formBuilder: FormBuilder, private readonly translate: TranslateService,
    readonly dialogRef: MatDialogRef<TagValueComponent>, @Inject(MAT_DIALOG_DATA) public data: ISelectedTag[]) {
    this.allUsedItems = data;
  }

  ngOnInit() {
    this.dynamicForm = this.formBuilder.group({
      rows: new FormArray([])
    });

    this.loadTagsDetails(this.allUsedItems);
    // translation
    this.translate.onLangChange.subscribe(langChange => this.getTranslation());
    this.getTranslation();

  }

  /**
   * get translation
   */
  getTranslation() {
    this.translate.get('Component').subscribe(components => this.trans = components);
  }

  // convenience getters for easy access to form fields
  get f() { return this.dynamicForm.controls; }
  get t() { return this.f.rows as FormArray; }
  get selectedItemsForm() { return this.t.controls as FormGroup[]; }

  /**
   * load tags details
   * @param allItems all used items
   */
  loadTagsDetails(allItems: ISelectedTag[] = []) {
    const numberOfTickets = allItems.length;
    if (this.t.length < numberOfTickets) {
      for (let i = this.t.length; i < numberOfTickets; i++) {
        this.t.push(this.formBuilder.group({
          name: [this.allUsedItems[i]?.name],
          type: [this.allUsedItems[i]?.type],
          itemType: [this.allUsedItems[i]?.itemType],
          value: [this.allUsedItems[i]?.value, Validators.required],
          variable: [this.allUsedItems[i]?.variable]
        }));
      }
    } else {
      for (let i = this.t.length; i >= numberOfTickets; i--) {
        this.t.removeAt(i);
      }
    }
  }

  //#region click events

  /**
   * on submit button click
   */
  onSubmit() {
    this.submitted = true;
    if (this.dynamicForm.value?.rows?.length) {
      this.dynamicForm.value.rows.forEach(tag => {
        tag.value = (tag.type !== this.dataTypes.Number) ? tag.value : Number(tag.value);
      });
    }

    const payload: string = this.dynamicForm.value?.rows;
    // dialog ref close
    this.dialogRef.close(payload);
  }

  /**
   * on close button click
   */
  onClose() {
    this.dynamicForm.reset();
    this.t.clear();
    this.dialogRef.close();
  }

  onReset() {
    // reset whole form back to initial state
    this.submitted = false;
    this.dynamicForm.reset();
    this.t.clear();
  }

  onClear() {
    // clear errors and reset ticket fields
    this.submitted = false;
    this.t.reset();
  }

  //#endregion

  //#region validation expression

  /**
 * value validation (on key press)
 * @param event event
 */
  valueValidation(event: any, type: string) {
    if (type !== this.dataTypes.Number) {
      var regex = new RegExp("^[a-zA-Z0-9_ ]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    } else {
      var regex = new RegExp("^[+-]?[0-9]*$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    }
  }

  //#endregion

}
